import * as React from 'react';

import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';

const BarcodeScanIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props}>
      <Path d="M13.535 2.844V5.03a.656.656 0 0 1-1.312 0V3.5H10.69a.656.656 0 1 1 0-1.313h2.188a.656.656 0 0 1 .656.657ZM5.004 10.5H3.473V8.969a.656.656 0 1 0-1.313 0v2.187a.656.656 0 0 0 .656.656h2.188a.656.656 0 1 0 0-1.312Zm7.875-2.188a.656.656 0 0 0-.656.657V10.5H10.69a.656.656 0 1 0 0 1.313h2.188a.656.656 0 0 0 .656-.657V8.97a.656.656 0 0 0-.656-.656ZM2.816 5.688a.656.656 0 0 0 .657-.657V3.5h1.53a.656.656 0 0 0 0-1.313H2.817a.656.656 0 0 0-.656.657V5.03a.656.656 0 0 0 .656.657ZM5.66 4.375a.656.656 0 0 0-.656.656V8.97a.656.656 0 1 0 1.312 0V5.03a.656.656 0 0 0-.656-.656Zm5.031 4.594V5.03a.656.656 0 1 0-1.312 0V8.97a.656.656 0 1 0 1.312 0ZM7.848 4.375a.656.656 0 0 0-.657.656V8.97a.656.656 0 1 0 1.313 0V5.03a.656.656 0 0 0-.656-.656Z" />
    </Icon>
  );
};

export default BarcodeScanIcon;
